import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import React, { useState } from "react";
import "./ConditionalDisplay.scss";

interface IProps {
    title: string;
    text?: string;
    component: any;
}

function ConditionalDisplay(props: IProps) {
    const [show, setShow] = useState(false);

    return (
        <div className="conditionalDisplayCommonDiv">
            <div
                className={`${"conditionalDisplayCommon"} ${show && "conditionalDisplayNoBorder"}`}
                onClick={() => setShow(!show)}
            >
                <div className="detailsConditional">
                    <div className="conditionalHeader">{props.title}</div>
                    {props.text && <div className="conditionalBody">{props.text}</div>}
                </div>
                <div className="arrowDiv" onClick={() => setShow(!show)}>
                    <div className="arrowInnerDiv">
                        <FontAwesomeIcon
                            icon={show ? faChevronUp : faChevronDown}
                            className="conditionalDisplayArrow"
                        />
                    </div>
                </div>
            </div>
            {show && <div className="innerComponentDiv">{props.component()}</div>}
        </div>
    );
}

export default ConditionalDisplay;
